<template>
  <b-modal
    id="modal-bailiff-process"
    ref="bailiff-Process-Modal"
    centered
    :title="$t('DEBTIA_BAILIFF_PROCESS_MODAL_TITLE')"
    :ok-title="$t('DEBTIA_SUBMIT')"
    :no-close-on-backdrop="true"
    cancel-variant="outline-secondary"
    size="md"
    @ok="submitProcess"
    @close="resetProcessModal"
  >
    <b-overlay
      id="overlay-background"
      :show="loaderModal"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-alert
        v-if="errorMsg"
        variant="warning"
        show
      >
        <div class="alert-body">
          <span v-if="errorMsg">{{ errorMsg }}</span>
        </div>
      </b-alert>
      <form
        ref="bailiffProcessForm"
      >
        <validation-observer
          ref="bailiffProcessRules"
          tag="form"
        >
          <b-row>
            <b-col md="12">
              <validation-provider
                #default="{ errors }"
                name="Concluded Date"
                :rules="getRules(dateOption)"
              >
                <b-form-group
                  :label="$t('DEBTIA_CONCLUDED_DATE')"
                  :state="errors.length > 0 ? false:null"
                >
                  <b-input-group>
                    <cleave
                      v-model="daConcludedDate"
                      class="form-control"
                      :raw="false"
                      :options="options.date"
                      placeholder="DD-MM-YYYY"
                      data-id="datepicker"
                      data-fieldtype="input"
                      @input="validateDate(0, daConcludedDate)"
                    />
                    <b-input-group-append>
                      <b-form-datepicker
                        v-model="concludedDate"
                        :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }"
                        trim
                        button-only
                        right
                        size="sm"
                        data-id="datepicker"
                        data-fieldtype="input"
                        @input="validateDate(1, concludedDate)"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col
              md="12"
            >
              <validation-provider
                #default="{ errors }"
                name="To Client"
                rules="required"
              >
                <b-form-group
                  :label="$t('DEBTIA_TO_CLIENT')"
                  :state="errors.length > 0 ? false:null"
                >
                  <b-form-input
                    v-model="toClient"
                    type="number"
                    step="0.01"
                    required
                  />
                  <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              md="12"
            >
              <validation-provider
                #default="{ errors }"
                name="To Us"
                rules="required"
              >
                <b-form-group
                  :label="$t('DEBTIA_TO_US')"
                  :state="errors.length > 0 ? false:null"
                >
                  <b-form-input
                    v-model="toUs"
                    type="number"
                    step="0.01"
                    required
                  />
                  <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </validation-observer>
      </form>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BFormGroup, BFormInput, BFormDatepicker, BRow, BCol, BOverlay, BFormInvalidFeedback, BAlert, BInputGroupAppend, BInputGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import axios from '@axios'
import Cleave from 'vue-cleave-component'
import { EventBus } from '@/event-bus'
import constants from '@/app-configs/constants'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  name: 'BailiffProcessModal',
  components: {
    BFormGroup,
    BFormInput,
    BFormDatepicker,
    Cleave,
    BRow,
    BCol,
    BAlert,
    BOverlay,
    ValidationObserver,
    ValidationProvider,
    BFormInvalidFeedback,
    BInputGroupAppend,
    BInputGroup,
  },
  props: {
    processId: {
      type: Number,
      required: true,
    },
  },
  data() {
    const date = new Date()
    const dd = String(date.getDate()).padStart(2, '0')
    const mm = String(date.getMonth() + 1).padStart(2, '0')
    const yyyy = date.getFullYear()
    return {
      concludedDate: '',
      daConcludedDate: `${dd}-${mm}-${yyyy}`,
      toClient: null,
      toUs: null,
      required,
      loaderModal: false,
      errorMsg: '',
      caseId: this.$route.params.id,
      options: {
        date: {
          date: true,
          delimiter: '-',
          datePattern: ['d', 'm', 'Y'],
        },
      },
      dateOption: '',
    }
  },
  methods: {
    getRules(option) {
      let validationRules = ''
      if (option === 1) {
        validationRules = 'required|datePattern'
      } else {
        validationRules = 'required'
      }
      return validationRules
    },
    validateDate(type, value) {
      if (type === 0) {
        this.concludedDate = this.$FormformattedDate(value)
      } else {
        this.daConcludedDate = this.$DAformattedDate(value)
      }
    },
    submitProcess(e) {
      e.preventDefault()
      this.$refs.bailiffProcessRules.validate().then(success => {
        if (success) {
          this.loaderModal = true
          const url = `${constants.baseUrl}/process/case/conclude`
          const obj = {
            process_id: this.processId,
            concluded_date: this.concludedDate,
            debt_case_id: this.caseId,
            to_client: this.toClient,
            to_us: this.toUs,
          }
          axios.post(url, obj).then(response => {
            this.loaderModal = false
            if (response.status === 200) {
              EventBus.$emit('refreshStatmentWidget')
              EventBus.$emit('refreshDocuments')
              EventBus.$emit('refreshModules')
              this.$refs['bailiff-Process-Modal'].hide()
              this.resetProcessModal()
            }
          }).catch(error => {
            this.loaderModal = false
            if (error.response.data.message) {
              this.errorMsg = error.response.data.message
            }
          })
        }
      })
    },
    resetProcessModal() {
      const date = new Date()
      const dd = String(date.getDate()).padStart(2, '0')
      const mm = String(date.getMonth() + 1).padStart(2, '0')
      const yyyy = date.getFullYear()
      this.concludedDate = `${dd}-${mm}-${yyyy}`
      this.daConcludedDate = `${dd}-${mm}-${yyyy}`
      this.toClient = null
      this.toUs = null
      this.errorMsg = ''
    },
  },
}
</script>
